// src/web/components/diary-report-active-user-bar.jsx

import React from 'react'
import { translate } from 'react-i18next'
import { themr } from 'react-css-themr'
import diaryReportTheme from './themes/diary-report.css'
import moment from 'moment'
import connect from "../../connects/diary-report-active-user-bar";

@themr('DiaryReportActiveUserBar', diaryReportTheme)
class DiaryReportActiveUserBar extends React.Component {
  render() {
    const {
      t,
      theme,
      attach_json,
      group,
      diary,
      lang,
      openReportStatusPage,
    } = this.props

    if (!attach_json) return null

    const { report_data } = attach_json
    if (!report_data || Object.keys(report_data).length === 0) return null

    const { active_user_bar_data } = report_data
    if (!active_user_bar_data || Object.keys(active_user_bar_data).length === 0) return null

    const isNewTemplate = Object.keys(active_user_bar_data).includes('posts')

    if (isNewTemplate) {
      const subject = t('label:report_subject', {
        month: moment(diary.created_at).format(t('format:month')),
        group_name: group.name,
      })

      const collectionDate = t('label:report_collection', {
        start_date: active_user_bar_data.collection_start_date,
        end_date: active_user_bar_data.collection_end_date,
      })

      return (
        <div className={theme.report} style={{ margin: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
          <div style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '20px' }}>
            {subject} <br />
            {collectionDate}
          </div>

          <div style={{ marginTop: '20px', fontSize: '14px' }}>
          {lang === 'en' ? (
              <span>
                ・Please see  
                <a  
                  onClick={() => {openReportStatusPage();}}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'blue', margin: '0 4px' , textDecoration: 'underline', cursor: 'pointer'}}
                >
                  here
                </a>
                for the specific submission status.
              </span>
            ) : (
              <span>
                ・具体的な提出状況は
                <a
                  onClick={() => {openReportStatusPage();}}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                >
                  こちら
                </a>
                からご覧ください。
              </span>
            )}
          </div>

          <div style={{ fontSize: '14px' }}>
            {lang === 'en' ? (
              <span>
                ・Please refer to
                <a
                  href="https://support.getgamba.com/hc/ja/articles/15569764486553-%E6%97%A5%E5%A0%B1%E3%81%AE%E6%8F%90%E5%87%BA%E4%BA%88%E5%AE%9A%E6%97%A5%E3%82%92%E7%99%BB%E9%8C%B2%E3%81%99%E3%82%8B"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'blue', margin: '0 4px' }}
                >
                  this user guide
                </a>
                for instructions on how to set the planned submission date.
              </span>
            ) : (
              <span>
                ・提出予定日の設定方法は
                <a
                  href="https://support.getgamba.com/hc/ja/articles/15569764486553-%E6%97%A5%E5%A0%B1%E3%81%AE%E6%8F%90%E5%87%BA%E4%BA%88%E5%AE%9A%E6%97%A5%E3%82%92%E7%99%BB%E9%8C%B2%E3%81%99%E3%82%8B"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'blue' }}
                >
                  こちらの使い方ガイド
                </a>
                をご覧下さい。
              </span>
            )}
          </div>

          <div style={{ fontSize: '14px' }}>
            ・{t('label:gamba!にご相談')}
          </div>

          <div style={{ fontSize: '14px' }}>
            {t('label:ご予約はこちら')}:
            <a
              href="https://meetings.hubspot.com/na-yamada/meeting"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'blue' }}
            >
              {t('label:gamba!活用サポート予約窓口')}
            </a>
          </div>
        </div>
      )
    } else {
      const {
        before_active_user_percentage,
        active_user_percentage,
        response_kind,
        response_change_amount,
      } = active_user_bar_data

      let report_message = ''
      if (active_user_percentage === 0) {
        report_message = t('label:日報の提出数がなし')
      } else if (active_user_percentage >= 90) {
        report_message = t('label:日報の提出数が90%以上')
      } else if (before_active_user_percentage <= active_user_percentage) {
        report_message = t('label:日報の提出数が増加')
      } else {
        report_message = t('label:日報の提出数が減少')
      }

      const response_kind_message =
        response_kind === 'nothing'
          ? t('label:レスポンスなし')
          : response_kind === 'like_only'
          ? t('label:レスポンスいいねのみ')
          : ''

      const response_change_amount_message =
        response_change_amount === 'up'
          ? t('label:レスポンス量増加')
          : response_change_amount === 'down'
          ? t('label:レスポンス量減少')
          : ''

      const subject =
        report_data.interval === 'monthly'
          ? t('label:月間レポート')
          : t('label:週間レポート')

      return (
        <div className={theme.report} style={{ margin: '20px', paddingLeft: '20px', paddingRight: '20px' }}>
          <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>
            {subject}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontSize: '20px',
              fontWeight: 'bold',
              marginBottom: '20px',
            }}
          >
            <div>提出率</div>
            <div>{active_user_percentage}％</div>
          </div>
          <div>
            <div style={{ backgroundColor: '#3C82F6', height: '10px', width: '100%', borderRadius: '5px' }}>
              <div
                style={{
                  backgroundColor: '#1C4ED8',
                  height: '10px',
                  width: active_user_percentage + '%',
                  borderRadius: '5px',
                }}
              ></div>
            </div>
          </div>
          <div style={{ marginTop: '10px', fontSize: '14px' }}>{report_message}</div>
          <div style={{ marginTop: '10px', fontSize: '14px' }}>{response_kind_message}</div>
          <div style={{ marginTop: '10px', fontSize: '14px' }}>{response_change_amount_message}</div>
        </div>
      )
    }
  }
}

export default connect(DiaryReportActiveUserBar)



// WEBPACK FOOTER //
// ./src/web/components/diary-report-active-user-bar.jsx